import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import QuickbetLobbyComponent from "../Components/QuickbetLobbyComponent";

interface QBLProps {
    atagParams: string | null,
    mode?: string | null
    sourceParams: string | null,
}
const QuickbetLobby: FC <QBLProps> = ({atagParams, mode, sourceParams}) => {
    const {getQuickbetsData} = useAction();
    const {quickbetsData} = useTypedSelector((state) => state.quickbetsReducer);
    useEffect(()=>{
        getQuickbetsData();
    }, [])
    return (
        <>
            {
                quickbetsData.length > 0 ?
                    <QuickbetLobbyComponent data={quickbetsData} sourceParams={sourceParams} atagParams={atagParams} mode={mode}  />
                    : null
            }
        </>
    );

}

export default QuickbetLobby;
